export default {
  items: [
    {
      name: 'Inicio',
      url: '/',
      icon: 'fa fa-dashboard'
    },
    {
      name: 'Cargar CSV Moodle',
      url: '/admin/subirCSV',
      icon: 'fa fa-upload'
    },
    {
      name: 'Cargar CSV Cargue masivo',
      url: '/admin/subirCSVCargue',
      icon: 'fa fa-upload'
    },
    {
      name: 'Descargar reportes',
      url: 'https://drive.google.com/drive/folders/1BrB-iX8kuWF0-xEOMpcSLH5P_ZDS6yE4?usp=sharing',
      icon: 'fa fa-download'
    },
    {
      title: true,
      name: 'Reportes',
      class: '',
      wrapper: {
        element: '',
        attributes: {}
      }
    },
    {
      name: 'Inspirados',
      url: '/reportes/inspirados',
      icon: 'fa fa-list'
    },
    {
      name: 'Inspiradores',
      url: '/reportes/inspiradores',
      icon: 'fa fa-list'
    },
    // {
    //   name: 'Sábana de datos',
    //   url: '/reportes/sabana',
    //   icon: 'fa fa-server'
    // },
    {
      name: 'Reporte MinTic',
      url: '/reportes/minTic',
      icon: 'fa fa-server'
    },
    {
      title: true,
      name: 'Inspiradores',
      class: '',
      wrapper: {
        element: '',
        attributes: {}
      }
    },
    {
      name: 'Inspiradores',
      url: '/inspiradores',
      icon: 'fa fa-list'
    },
    {
      name: 'Nuevo Inspirador',
      // url: '/inspiradores/crear',
      // url: '/',
      class: 'disabled',
      icon: 'fa fa-plus'
    }
  ]
}
